import AlertMessage from '@/app/components/AlertMessage'
import MenuCard, { MenuCardItem } from '@/components/MenuCard'
import { EnergySystem } from '@/types/energySystem'

type Props = {
  energySystem: EnergySystem
}

function formatOperationalMode(operationalMode: string) {
  return (
    operationalMode
      // turn underscores to spaces
      .replace(/_/g, ' ')
      // capitalize each word
      .replace(/\b\w/g, (char) => char.toUpperCase())
  )
}

function EnergySystemsSettingsMenuCard(props: Props) {
  const operationalMode = formatOperationalMode(
    props.energySystem.operating_mode_setting,
  )
  const gridChargingAllowed = props.energySystem.grid_charging_allowed
  return (
    <MenuCard icon="Settings" title="Battery Settings" iconColor="grey-500">
      <MenuCardItem
        id="energy-system-operational-mode-menu-item"
        loading={false}
        rightLabel={operationalMode}
        label="Operational Mode"
        className="mb-4"
      />
      <MenuCardItem
        id="thermostat-notification-settings-menu-item"
        loading={false}
        rightLabel={gridChargingAllowed ? 'Yes' : 'No'}
        label="Grid Charging"
      />
    </MenuCard>
  )
}

function EnergySystemsDRSettingsAlert() {
  return (
    <AlertMessage variant="info">
      We currently only change your settings for demand response (DR) events. We
      do not use your battery's data to control your EV, charger or thermostat
    </AlertMessage>
  )
}

export default function EnergySystemDevicesSettingsTab(props: Props) {
  return (
    <section className={'flex flex-col w-full gap-4'}>
      <EnergySystemsDRSettingsAlert />
      <EnergySystemsSettingsMenuCard energySystem={props.energySystem} />
    </section>
  )
}
